"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _followUps = require("@/api/follow-ups");
var _index = require("@/utils/index");
var _admin = require("@/store/modules/admin");
var _agendaLabels = require("@/utils/agendaLabels");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.list = [];
    this.startDate = '';
    this.endDate = '';
    this.loggedInUser = null;
  }
  created() {
    this.loggedInUser = _admin.AdminModule;
    // if (this.dateRange && this.dateRange.start && this.dateRange.end) {
    //   this.startDate = this.dateRange.start
    //   this.endDate = this.dateRange.end
    //   this.fetchData()
    // } else {
    //   const date = new Date()
    //   this.dateRange.end = date.toISOString()
    //   date.setMonth(date.getMonth() - 2)
    //   this.dateRange.start = date.toISOString()
    // }
    this.fetchData();
  }
  async fetchData() {
    const response = await (0, _followUps.getFollowUps)((0, _index.getQuery)({
      assignedTo: this.loggedInUser.id,
      status: 'Pending',
      filter: {
        assignedTo: '$eq',
        status: '$eq'
      }
    }));
    this.list = this.transformEventsToCalendar(response);
  }
  transformEventsToCalendar(events) {
    const date = new Date().toLocaleDateString();
    const daysOfWeek = [date];
    const startHour = 8;
    const endHour = 18;
    // Initialize the calendar structure
    const calendar = [];
    for (let hour = startHour; hour < endHour; hour++) {
      const timeSlot = `${hour} AM`;
      const entry = {
        time: timeSlot
      };
      entry[date] = '';
      calendar.push(entry);
    }
    // Populate the calendar with events
    events.forEach(event => {
      const dueDate = new Date(event.dueDate);
      const dayOfWeekIndex = (dueDate.getUTCDay() + 6) % 7; // Adjust to Monday start
      const hourOfDay = dueDate.getUTCHours();
      if (hourOfDay >= startHour && hourOfDay < endHour) {
        const calendarIndex = hourOfDay - startHour;
        const dayOfWeek = daysOfWeek[dayOfWeekIndex];
        calendar[calendarIndex][dayOfWeek] = _agendaLabels.agendaLabels[event.agenda] || event.agenda;
      }
    });
    return calendar;
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'TasksEvent',
  components: {}
})], default_1);
var _default = exports.default = default_1;